"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxFormFieldByConfig = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _SharedStyledComponents = require("./SharedStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const StyledFormControlLabel = (0, _mui.styled)(_mui.FormControlLabel)(({
  theme
}) => ({
  alignItems: 'start'
}));
const StyledCheckbox = (0, _mui.styled)(_mui.Checkbox)(({
  theme
}) => ({
  paddingTop: theme.spacing(0)
}));
const customRequiredFields = new Set(['legalDetails.confirmation1', 'legalDetails.confirmation2', 'legalDetails.termsAndConditions']);
const CheckboxFormFieldByConfig = props => {
  const {
    name,
    label,
    isAvailable,
    displayOrder,
    isSubmitting,
    isMandatory,
    onChange
  } = props;
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const customRequired = customRequiredFields.has(name);
  const renderField = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12
    },
    style: {
      order: displayOrder
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
      minWidth: 100,
      mb: 2,
      textAlign: "left",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
        name: name,
        render: ({
          field,
          fieldState
        }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SharedStyledComponents.StyledFormControl, {
          error: !!fieldState.error,
          disabled: isSubmitting,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFormControlLabel, {
            control: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCheckbox, {
              color: "primary",
              required: customRequired ? false : isMandatory,
              value: field.value,
              disabled: isSubmitting,
              checked: field.value,
              inputRef: field.ref
              // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical operator ||
              ,
              onChange: onChange || field.onChange,
              ...getTestIdProps(`${name}-checkbox-field`)
            }),
            label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
              variant: "body1",
              sx: {
                fontWeight: field.value ? 'bold' : 'normal'
              },
              children: label
            }),
            id: name,
            disabled: isSubmitting
          }), fieldState.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
            error: true,
            children: fieldState.error.message
          }) : null]
        })
      })
    })
  });
  const fieldComponent = isAvailable && renderField();
  return fieldComponent;
};
exports.CheckboxFormFieldByConfig = CheckboxFormFieldByConfig;
